export default __webpack_public_path__ + "static/media/eyes1.be43ae23.png";